/* Brewie — Flavor Rail
   The carousel from POUR-RITUAL/previz/index.html. The tiles are rendered by
   Liquid so the products, prices and links are real; this only clones that set
   either side to make the wrap seamless, then carries the previz's scroll
   behaviour across unchanged. */
(function(){
  const SETS = 3;                  // one real set flanked by a clone either side
  const root = document.querySelector('[data-flavor-rail]');
  if (!root) return;
  const rail = root.querySelector('[data-rail]');
  if (!rail) return;

  // Liquid rendered one real set. Clone it before and after, and take the
  // copies out of the accessibility tree and the tab order so the same product
  // is never announced or focused three times.
  const real = [...rail.children];
  if (!real.length) return;
  const clone = () => real.map(el => {
    const c = el.cloneNode(true);
    c.setAttribute('aria-hidden', 'true');
    c.querySelectorAll('a,button,input,select,textarea').forEach(n => n.tabIndex = -1);
    return c;
  });
  rail.prepend(...clone());
  rail.append(...clone());


  const stepBy = () => {
    const tile = rail.querySelector('.pz-tile');
    const gap  = parseFloat(getComputedStyle(rail).gap) || 16;
    return tile ? tile.offsetWidth + gap : 280;
  };

  // Wrap through the middle set so the rail never reaches an end.
  let setW = 0, wrapping = false;
  function measure(){
    setW = rail.scrollWidth / SETS;
    jump(setW);
  }
  function jump(x){
    wrapping = true;
    const prev = rail.style.scrollBehavior;
    rail.style.scrollBehavior = 'auto';
    rail.scrollLeft = x;
    rail.style.scrollBehavior = prev || '';
    requestAnimationFrame(() => { wrapping = false; });
  }
  rail.addEventListener('scroll', () => {
    if (wrapping || !setW) return;
    const x = rail.scrollLeft;
    if (x < setW * 0.5)      jump(x + setW);
    else if (x > setW * 1.5) jump(x - setW);
  }, {passive:true});

  // Trackpad horizontal scroll runs the rail far faster than it reads, and the
  // browser's own scroll speed is not exposed - damping the wheel delta is the
  // only lever. Only horizontal-dominant gestures are taken, so a vertical swipe
  // over the rail still scrolls the page. behavior:'auto' is explicit because
  // the rail carries scroll-behavior:smooth for the arrow buttons, and letting
  // that animate every wheel tick would queue them into a lag.
  const WHEEL_DAMP = 0.4;
  let snapBack = 0;
  rail.addEventListener('wheel', e => {
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    e.preventDefault();
    // Snapping has to come off for the gesture. With scroll-snap-type set, the
    // browser re-snaps every sub-tile scroll straight back to the tile it was
    // already on, so a damped delta moves nothing at all - measured as exactly
    // 0px for both `mandatory` and `proximity`, and the full 80px for `none`.
    // Restoring it a beat after the gesture stops lets the rail settle onto a
    // tile the way a native flick would.
    // scroll-behavior has to come off too. The rail carries `smooth` for the
    // arrow buttons, and in ScrollToOptions `behavior:'auto'` means "use the
    // CSS value", not "instant" - so every tick queued an animation instead of
    // moving. Assigning scrollLeft with both suspended is what `jump()` does.
    rail.style.scrollSnapType  = 'none';
    rail.style.scrollBehavior  = 'auto';
    rail.scrollLeft += e.deltaX * WHEEL_DAMP;
    clearTimeout(snapBack);
    snapBack = setTimeout(() => {
      rail.style.scrollBehavior = '';
      rail.style.scrollSnapType = '';
    }, 140);
  }, { passive:false });

  // ---- click and drag -------------------------------------------------------
  // Touch already scrolls this natively, so only the mouse is intercepted.
  // Snapping and smooth behaviour come off for the gesture for the same reason
  // they do for the wheel: with them on, every sub-tile move is snapped back.
  const DRAG_SLOP = 4;                 // px of travel before it counts as a drag
  let down = false, dragging = false, startX = 0, startLeft = 0, moved = 0;

  rail.addEventListener('pointerdown', e => {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    down = true; dragging = false; moved = 0;
    startX = e.clientX; startLeft = rail.scrollLeft;
    // Deliberately no setPointerCapture here. Capturing on pointerdown
    // retargets the follow-up click to the rail, so Add to cart never received
    // its own click. Capture starts only once this is actually a drag.
  });

  rail.addEventListener('pointermove', e => {
    if (!down) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > moved) moved = Math.abs(dx);
    if (!dragging){
      if (moved <= DRAG_SLOP) return;  // still just a click
      dragging = true;
      try { rail.setPointerCapture(e.pointerId); } catch (_) {}
      rail.classList.add('is-dragging');
      rail.style.scrollSnapType = 'none';
      rail.style.scrollBehavior = 'auto';
    }
    rail.scrollLeft = startLeft - dx;
  });

  function endDrag(e){
    if (!down) return;
    down = false;
    if (!dragging) return;             // a plain click: leave everything alone
    dragging = false;
    rail.classList.remove('is-dragging');
    try { rail.releasePointerCapture(e.pointerId); } catch (_) {}
    rail.style.scrollBehavior = '';
    clearTimeout(snapBack);
    snapBack = setTimeout(() => { rail.style.scrollSnapType = ''; }, 140);
  }
  rail.addEventListener('pointerup', endDrag);
  rail.addEventListener('pointercancel', endDrag);

  // A drag that travelled must not also fire the click underneath it, or
  // letting go over a card would add it to the cart. Capture phase, so it is
  // stopped before the button ever sees it.
  rail.addEventListener('click', e => {
    if (moved > DRAG_SLOP){ e.preventDefault(); e.stopPropagation(); }
  }, true);

  // Images and links are natively draggable, which hijacks the gesture the
  // moment the cursor starts over one.
  rail.addEventListener('dragstart', e => e.preventDefault());

  // ---- add to cart, without leaving the page --------------------------------
  // Mirrors what the theme's own product forms do: POST /cart/add.js, then tell
  // the theme so the drawer and the count stay in sync. Both hooks are probed
  // rather than assumed, so a theme update that drops either one degrades to a
  // working button instead of a broken one.
  const ADDED_MS = 1600;

  root.addEventListener('submit', async e => {
    const form = e.target.closest('.pz-tile__form');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    if (btn && btn.dataset.busy) return;
    const label = btn ? btn.textContent : '';
    if (btn){ btn.dataset.busy = '1'; btn.disabled = true; }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form)).toString()
      });
      if (!res.ok) throw new Error('add failed: ' + res.status);

      // Re-read the whole cart: the drawer and the counter want cart state,
      // not just the line that was added.
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
      if (window.eventBus && window.eventBus.emit) window.eventBus.emit('update:cart:drawer', cart);
      if (window.theme && window.theme.updateCartCount) window.theme.updateCartCount(cart);
      if (root.dataset.afterAdd === 'open_drawer' && window.eventBus && window.eventBus.emit) {
        window.eventBus.emit('open:cart:drawer');
      }

      if (btn){
        btn.textContent = root.dataset.addedLabel || 'Added';
        btn.classList.add('is-added');
      }
    } catch (err) {
      // Last resort: let the browser do the normal form post so the customer
      // is never left with a button that silently does nothing.
      form.submit();
      return;
    } finally {
      setTimeout(() => {
        if (!btn) return;
        btn.disabled = false;
        delete btn.dataset.busy;
        btn.textContent = label;
        btn.classList.remove('is-added');
      }, ADDED_MS);
    }
  });

  const prev = root.querySelector('[data-rail-prev]');
  const next = root.querySelector('[data-rail-next]');
  prev.addEventListener('click', () => rail.scrollBy({left:-stepBy(), behavior:'smooth'}));
  next.addEventListener('click', () => rail.scrollBy({left: stepBy(), behavior:'smooth'}));

  addEventListener('resize', measure, {passive:true});
  measure();
  window.__brewieFlavorRail = { rail, setW: () => setW, tiles: () => rail.children.length };
})();